import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LocalStorageService } from '../local-storage.service';
import { DEFAULT_TIMEZONE, timezones } from '@properties/timezone.properties';
import { TimezoneInterface } from '@interfaces/timezone/timezone.interface';
import { TimezoneChangeEvent } from '@interfaces/timezone/timezone-change-event.interface';

@Injectable({
  providedIn: 'root',
})
export class TimezoneSharedService {
  timezones = timezones;
  selectedTimezone = this.localStorageService.getStoredTimezone();
  timezoneChange = new Subject<TimezoneChangeEvent>();

  constructor(private readonly localStorageService: LocalStorageService) {}

  get timezonesList(): TimezoneInterface[] {
    return Array.from(this.timezones.values());
  }

  get offsetMinutes(): number {
    const timezone = this.selectedTimezone ?? DEFAULT_TIMEZONE;

    const currentTimezone = timezone.title;
    let offsetMinute = timezone.offset;

    if (currentTimezone.includes('IST')) {
      offsetMinute = offsetMinute + 30;
    }

    return offsetMinute;
  }
}
